/*/
.. Gerar a build
Rodar na raiz do projeto "ng build"

.. Rodar a build localmente é necessário rodar um servidor (pro front-end)
Na pasta dist rodar: "npx serve -s"

.. Modificar as cores para o ambiente de desenvolvimento/homologação:
Nos arquivos
- src\scss\custom-variables.scss
- src\scss\_bootstrap-variables.scss
Trocar o valor da variável $ambienteProd para false
/*/

export const environment = {
  PRODUCAO: true,
  CARDEAL_EDICAO: 'TAKAHASHI',
  URL_API: 'https://sistema.takahashiadv.com.br/gateway/',
  URL_CACHE: 'https://sistema.takahashiadv.com.br/gateway/cache/',
  appInsights: {
    instrumentationKey: ''
  },
};
